import React,{Component} from "react";
import ContainerSection from './ContainerSection';
import Scrollable from '../../components/Scrollable';
import Translator from '../../requests/apa/Translator';

class MultiSection extends Component {

  state={
    status:false,
  }

  toggleStatus=()=>{
    this.setState({status:!this.state.status});
  }

  render() {
    let subsectionName = '';
    if (this.props.subsection) {
      subsectionName = ` / ${this.props.subsection}`
      return (
        <div id="section" className="content-view">
          <div className="header-settings">
            { Translator.get('parental_control_section_one_name', 'Configuración de TV') }<span>{ subsectionName }</span>
          </div>
          <hr/>
          <ContainerSection subsection={ this.props.subsection } />
        </div>
      );
    }
    else
      return (
        <Scrollable height={'450px'}>
          <div id="section" className="content-view" style={{height:'190px'}}>
            <div className="header-settings">
              {Translator.get(this.props.sectionOneName,'Configuración de TV')}
            </div>
            <hr/>
            <ContainerSection section={this.props.sectionOneName} subsection={ this.props.subsection } status={this.state.status} toggleStatus={this.toggleStatus}/>
          </div>
          <div id="section" className="content-view" style={{height:'210px'}}>
            <div className="header-settings">
              {Translator.get(this.props.sectionTwoName, 'Configuraciones de contenidos')}
            </div>
            <hr/>
            <ContainerSection section={ this.props.sectionTwoName} subsection={ this.props.subsection } status={this.state.status} toggleStatus={this.toggleStatus}  />
          </div>
        </Scrollable>
      );
  }
}

export default MultiSection;



// WEBPACK FOOTER //
// ./src/containers/User-Settings/MultiSection.jsx